export default __webpack_public_path__ + "d388893.png";